export const renderNamespace = (
  identity: Api.Response['describeUser']['identity'],
) =>
  identity?.namespace?.identityProvider?.identityProviderType?.name ||
  identity?.namespace?.nickname ||
  '???';
